// ****************************************/
// Input
// ****************************************/

import styled from "styled-components";
import { font, media } from "../Styles";

const InputStyles = styled.section`
  input {
    border: 1px solid ${props => props.theme.grey400};
    font-size: ${font.p};
    width: 100%;
    padding: 0.4rem 0.5rem 0 0.5rem;
    height: 2.8rem;
    background: transparent;
    border-radius: 0;
    -webkit-appearance: none;
    transform: 1s background cubic-bezier(0.645, 0.045, 0.355, 1),
      1s border cubic-bezier(0.645, 0.045, 0.355, 1);
    ${media.smallDesktopAndBelow`
      font-size: ${font.pTablet};
      height: 35px;
      padding: 4px 7px 0 7px;
    `}
    ${media.mobileOnly`
      font-size: ${font.pMobile};
    `}
  }

  input.has-value,
  input:focus,
  input:active {
    border: 1px solid black;
    outline: none;
  }

  input.has-error {
    /* background: ${props => props.theme.errorLight}; */
    border-color: ${props => props.theme.error};
    color: ${props => props.theme.error};
  }
`;

export default InputStyles;
